export default __webpack_public_path__ + "static/strategy_analysis_img_2-a063d4f7546eb1be8cd599a158e212d4.png";